// Leads module API client — contained mode. Wraps the host app's axios
// instance (@/lib/api: Bearer session token + 401 handling) and prefixes
// every path with /leads-mod → /api/leads-mod/* on the backend.

import hostApi from "@/lib/api";

export const LEADS_MOD_API = "/api/leads-mod";

const PREFIX = "/leads-mod";

const wrap =
  (fn) =>
  (url, ...rest) =>
    fn.call(hostApi, `${PREFIX}${url}`, ...rest);

export const api = {
  get: wrap(hostApi.get),
  post: wrap(hostApi.post),
  put: wrap(hostApi.put),
  patch: wrap(hostApi.patch),
  delete: wrap(hostApi.delete),
};

export async function getLeadColumns() {
    const { data } = await api.get("/leads/columns");
    return data.columns || [];
}

export async function saveLeadColumns(columns) {
    const { data } = await api.put("/leads/columns", { columns });
    return data.columns || [];
}

export async function listLeads() {
    const { data } = await api.get("/leads");
    return data;
}

export async function createLead(cells = {}) {
    const { data } = await api.post("/leads", { cells });
    return data;
}

export async function updateLead(id, payload) {
    const { data } = await api.patch(`/leads/${id}`, payload);
    return data;
}

export async function deleteLead(id) {
    const { data } = await api.delete(`/leads/${id}`);
    return data;
}

export async function convertLead(id, payload) {
    const { data } = await api.post(`/leads/${id}/convert`, payload);
    return data;
}

export async function importLeadsXps(file) {
    const fd = new FormData();
    fd.append("file", file);
    // .json = a leads export ([{cells:{...}, color, ...}]); anything else goes through the XPS/PDF parser
    const isJson = /\.json$/i.test(file.name || "") || file.type === "application/json";
    const { data } = await api.post(isJson ? "/leads/import-json" : "/leads/import-xps", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

// State-version poll for near-real-time cross-user sync.
export async function getLeadsStateVersion() {
    const { data } = await api.get("/leads/state-version");
    return data;
}

// Typing presence: heartbeat while editing + snapshot of who else is
// typing right now.
export async function heartbeatLeadTyping(leadId) {
    const { data } = await api.post(`/leads/${leadId}/typing`);
    return data;
}
export async function getLeadsTypingState() {
    const { data } = await api.get("/leads/typing-state");
    return data;
}
